export default "__VITE_ASSET__tY1KbcXC__"